module.exports = __webpack_public_path__ + "62d102bff8f876237e6312b0ac6b3ffc.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2111_teaser_image.jpg
// module id = 604
// module chunks = 0